import React from 'react';
import {FormFeedback, Input} from 'reactstrap';

export default function({field: {name, value, onChange, onBlur}, id, ...props}) {
  return (
    <Input name={name} type="radio" checked={props.value === value} onChange={onChange} onBlur={onBlur} {...props} />
  );
}
